
import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import SafeMotion from "@/components/motion/SafeMotion";
import MotionErrorBoundary from "@/components/motion/MotionErrorBoundary";
import { Button } from "@/components/ui/button";
import { ArrowUp, Eye, Heart, Share2 } from "lucide-react";

const FloatingActions = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <MotionErrorBoundary>
      <div className="fixed bottom-8 right-8 z-50 flex flex-col gap-4">
        <AnimatePresence>
          {showBackToTop && (
            <SafeMotion
              initial={{ opacity: 0, scale: 0.8, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.8, y: 20 }}
              transition={{ duration: 0.3 }}
              fallback={
                <div>
                  <Button
                    onClick={scrollToTop}
                    className="rounded-full p-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white shadow-2xl hover:shadow-purple-500/25 transition-all duration-300"
                    size="icon"
                  >
                    <ArrowUp className="h-6 w-6" />
                  </Button>
                </div>
              }
            >
            <Button
              onClick={scrollToTop}
              className="rounded-full p-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white shadow-2xl hover:shadow-purple-500/25 transition-all duration-300"
              size="icon"
            >
              <ArrowUp className="h-6 w-6" />
            </Button>
          </SafeMotion>
        )}
      </AnimatePresence>
    </div>
    </MotionErrorBoundary>
  );
};

export default FloatingActions;
